export default "__VITE_ASSET__C$N_YjUx__"